export default __webpack_public_path__ + "static/media/logo-linkedin.bcd76d7f.svg";